/**
 * pc 格栅默认最小为1200px. 但假如是关键词 “auto”, “inherit”, "fit-content"等, 直接返回
 */
export const formatGridWidth = (preWidth: number | string, minWidth: number = 0): string => {
	if (typeof preWidth === "number") {
		return `${Math.max(preWidth, minWidth)}px`;
	}
	return preWidth;
};

export const transformGridWidth2Number = (preWidth: number | string, minWidth: number = 0) => {
	if (typeof preWidth === "number") {
		return Math.max(preWidth, minWidth);
	}
	return 1200;
};
/**
 * 根据 画板的宽度和列数量计算单元格的宽度
 * @param contentWidth number  画板宽度
 * @param gridCol number 横向单元格数量
 * @param gridGap number 单元格间隙
 */
export function getCellWidthByGrid({
	contentWidth,
	gridCol,
	gridGap,
}: {
	contentWidth: number;
	gridGap: number;
	gridCol: number;
}) {
	return +((contentWidth - gridGap * (gridCol - 1)) / gridCol).toFixed(1);
}
